import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { path } from 'ramda';

// Components
import {
  I18n,
  Link,
  Icon,
  Preloader,
} from 'components';
import classNames from 'classnames/bind';
import Subscription from '../../components/Subscription';

// Actions
import { fetchData, refetchData, disconnectSubscription } from '../../actions';

// Styles
import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

class Subscriptions extends Component {
  static buildServiceConfig(actions, subscription) {
    return {
      actions,
      key: `subscription-${subscription.id}`,
      title: subscription.name,
      provider: subscription.providerName,
      description: subscription.category,
      rate: subscription.priceDescription ? null : subscription.currentPrice,
      textRate: subscription.priceDescription,
      priceDescription: subscription.priceDescription,
      priceNote: subscription.duration,
      ratePeriod: subscription.unit,
      subscriptionId: subscription.id,
      subscriptionType: subscription.subscriptionType,
      futurePriceDate: new Date(subscription.futurePriceDate),
      futurePrice: subscription.futurePrice,
      productParameters: subscription.productParameters,
      isActive: subscription?.isActive,
      enabled: subscription?.enabled,
      isPartner: subscription?.isPartner,
    };
  }

  componentDidMount() {
    this.props.actions.fetchData(['Subscriptions']);
  }

  getCertainSubscriptions = (subscriptions, type) => subscriptions.reduce((acc, subscription) => {
    if (type === 'fun' && subscription.subscriptionType === 'CDP'
      || type === 'partners'
      && (subscription.subscriptionType === 'CPA' || subscription.subscriptionType === 'PartnerService')) {
      return [...acc, subscription];
    }
    return acc;
  }, []);

  render() {
    const {
      actions,
      isError,
      isLoading,
      subscriptions,
      isRestrictedAccess,
      type,
    } = this.props;

    if (isLoading) {
      return (
        <div className={cx('preloaderWrapper')}>
          <Preloader className={cx('preloader')} size="80" />
        </div>
      );
    }

    if (isError) {
      return (
        <div className={cx('container', 'message')}>
          <Icon className={cx('icon')} name="smile-dead" />
          <div>
            <I18n path="services.subscriptionsLoadingError" />
            <br />
            <I18n path="services.try" />
            &nbsp;
            <Link onClick={() => actions.refetchData('Subscriptions')}>
              <I18n path="services.refresh" />
            </Link>
            &nbsp;
            <I18n path="services.inAMinute" />
          </div>
        </div>
      );
    }

    if (subscriptions && !subscriptions.length) {
      return (
        <div className={cx('container', 'message')}>
          <I18n path="services.subscriptionsEmptyMessage" />
          {' '}
          <I18n path="services.goTo" />
          {' '}
          <Link href="http://www.beeonline.ru/" target="_blank">
            <I18n path="services.subscriptionCatalog" />
          </Link>
        </div>
      );
    }

    return (
      <div className={cx('container')}>
        {subscriptions && this.getCertainSubscriptions(subscriptions, type)
          .map((subscription) => (
            <Subscription
              isRestrictedAccess={isRestrictedAccess}
              {...Subscriptions.buildServiceConfig(actions, subscription)}
            />
          ))}

        <div className={cx('catalogLink')}>
          <I18n path="services.goTo" />
          {' '}
          <Link href="http://www.beeonline.ru/" target="_blank">
            <I18n path="services.subscriptionCatalog" />
          </Link>
        </div>
      </div>
    );
  }
}

Subscriptions.defaultProps = {
  isError: false,
  isLoading: false,
};

Subscriptions.propTypes = {
  actions: PropTypes.shape({
    fetchData: PropTypes.func,
    refetchData: PropTypes.func,
    disconnecSubscription: PropTypes.func,
  }),
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  subscriptions: PropTypes.array,
  isRestrictedAccess: PropTypes.bool,
  type: PropTypes.string,
};

const mapStateToProps = ({
  services,
  application,
}) => {
  const {
    error,
    isPreloader,
    subscriptions,
  } = services;
  const { data } = subscriptions;

  return {
    subscriptions: data,
    isError: Boolean(error),
    isLoading: isPreloader && services.loadingBlocks.some((i) => i === 'Subscriptions'),
    isRestrictedAccess:
      application.settings.isRestrictedAccess
      || path(['status', 'data', 'status'], services) === 'Blocked',
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchData,
      refetchData,
      disconnectSubscription,
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
